<template>
  <b-field>
    <div class="question-content label" v-html="question"></div>
    <b-input
      ref="text"
      type="textarea"
      v-model="answer"
      @input="onInput"
      :placeholder="placeholder"
      :disabled="disabled"></b-input>
  </b-field>
</template>

<script>
export default {
  props: {
    question: {
      type: String,
      required: true
    },
    placeholder: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      answer: ''
    }
  },
  methods: {
    onInput() {
      this.$emit('input', this.answer)
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "../../../assets/scss/variables";


  /deep/ .label {
    font-size: 2rem;
    padding-bottom: 2rem;
  }

  /deep/ textarea {
    border: 2px solid $dark;
    &:hover, &:focus {
      border: 2px solid $dark;
      box-shadow: 0 0 0 0.125em rgba($dark, 0.2);
    }

    &:not([rows]) {
      min-height: 220px;
    }

    &::placeholder {
      color: $dark;
      opacity: 0.5;
    }
  }

  .field.has-addons {
    display: block;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: center;
  }

  .question-content {
    margin-bottom: 45px;
  }

</style>
